import type { ComponentPropsOptions, PropType } from "vue";
import type { FlexComponent } from "@/utils/render-component";
import { Icon } from "@iconify/vue";
import { defineComponent } from "vue";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";
import { renderComponent } from "@/utils/render-component";

const iconProps = {
  icon: {
    type: [String, Object, Function] as PropType<string | FlexComponent>,
    required: true,
  },
  class: p.custom<string | any[]>([String, Array]),
} satisfies ComponentPropsOptions;

export default defineComponent({
  name: "Icon",
  props: iconProps,
  setup(props) {
    return () => (
      <div data-slot="icon" class={cn("size-5 w-auto shrink-0", props.class)}>
        {typeof props.icon === "string" ? (
          <Icon icon={props.icon} height="100%" class="stroke-thin" />
        ) : (
          renderComponent(props.icon)
        )}
      </div>
    );
  },
});
